export default __webpack_public_path__ + "static/media/029-truck.7db6cef1.svg";